import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Sentiment } from '@sb-tools/typescript/enums/sentiment.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'sentiment' })
export class SentimentPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(sentiment: Sentiment): string {
        switch (sentiment) {
            case Sentiment.all:
                return this.translateService.instant('All');
            case Sentiment.question:
                return this.translateService.instant('Questions');
            case Sentiment.praise:
                return this.translateService.instant('Praises');
            case Sentiment.suggestion:
                return this.translateService.instant('Suggestions');
            case Sentiment.complaint:
                return this.translateService.instant('Complaints');
            default:
                return this.translateService.instant('Unknown sentiment');
        }
    }
}
